import Dashboard from '../containers/dashboard'
import PaymentsCompletedManagement from '../containers/payments-completed-management'

const PaymentsCompleted = () => {
  return (
    <Dashboard>
      <PaymentsCompletedManagement />
    </Dashboard>
  )
}

export default PaymentsCompleted
